<template>
  <div class="order">
    <div class="top-navbar">
      <div class="main-container">
        <div class="row">
          <div class="col-auto">
            <router-link to="/" tag="button" class="top-navbar__back" typeof="submit">
              <i class="icon-angle-left"></i>
              {{ t('message["Add Order"]', 'Add Order') }}
            </router-link>
          </div>
          <div class="col-auto ml-auto">
            <button v-if="settings.call_a_waiter" @click="$emit('call-a-waiter')" class="btn btn-success mb-3" type="submit"  id="call-waiter-button">
              {{ t('message["Call a Waiter"]', 'Call a Waiter') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="n-modal__inner">
      <div class="n-modal__cont">
        <div class="n-modal__title">{{ t('message["Items from Order #"]', 'Items from Order #') }} {{ order.id }}</div>
        <!-- <div class="n-modal__place"><i class="icon-place"></i> 856 Esta Underpass</div> -->
        
        <div class="table-responsive">
          <table class="table-total">
            <tbody v-if="order.products">
              <tr v-for="item in order.products" :key="item.order_price">
                <td class="table-total__name">{{ item.product[0].name[language.key] }}</td>
                <td>{{ item.order_quantity }}</td>
                <td align="right" class="table-total__price"> {{ item.order_price * item.order_quantity }} AED</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div class="separator">
        <div class="separator__inner"></div>
      </div>
      
      <div class="n-modal__cont">
        <div class="n-modal__label">{{ t('message["Notes"]', 'Notes') }}</div>
        <p>{{ order.note }}</p>
        <div class="total">
          <div class="total__name col-auto">{{ t('message["Total"]', 'Total') }}</div>
          <div class="total__price col-auto ml-auto">{{ order.grand_total }} AED</div>
        </div>
      </div>
      
      <button class="n-modal__submit" @click="$emit('bill-request')" typeof="submit" style="width: 100%">
        {{ t('message["Bill Request"]', 'Bill Request') }}
      </button>
    </div>


    
    
  </div>
</template>

<script>
import translate from '../../mixins/translate'

export default {
  mixins: [translate],
  props: {
    order: {
      type: Object,
      default: () => ({})
    },
    language: {
      type: Object,
      default: () => ({})
    },
    settings: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
